// Client-side projected score calculator — mirrors backend scoring.py.
export const calculateProjectedScore = (currentScore, items, checkedIds) => {
  const gain = items
    .filter((it) => checkedIds.includes(it.id || it.action))
    .reduce((acc, it) => acc + (it.potentialGain || 0), 0);
  return Math.min(100, Math.round(currentScore + gain));
};

export const scoreToGrade = (score) => {
  if (score >= 90) return "A";
  if (score >= 75) return "B";
  if (score >= 60) return "C";
  if (score >= 40) return "D";
  return "F";
};

export const scoreToColor = (score) => {
  if (score >= 75) return "var(--rg-sage)";
  if (score >= 60) return "var(--rg-amber)";
  if (score >= 40) return "var(--rg-amber)";
  return "var(--rg-red)";
};

// Readiness Score band labels (v4 — informational, no legal-obligation framing)
export const scoreToBand = (score) => {
  if (score >= 90) return "Strong Readiness";
  if (score >= 75) return "Good Readiness";
  if (score >= 60) return "Moderate Readiness — Review Suggested";
  if (score >= 40) return "Low Readiness — Advisor Consultation Suggested";
  return "Significant Gaps — Professional Review Recommended";
};

export const TIER_LIMITS = {
  free: 1,
  solo: 2,
  growth: 3,
  agency: 25,
  // Legacy pro tier kept for safety
  pro: 5,
};
